import { render } from "./ObTracingList.vue?vue&type=template&id=485f7f40&scoped=true"
import script from "./ObTracingList.vue?vue&type=script&lang=js"
export * from "./ObTracingList.vue?vue&type=script&lang=js"

import "./ObTracingList.vue?vue&type=style&index=0&id=485f7f40&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485f7f40"]])

export default __exports__